module.exports = __webpack_public_path__ + "img/grid-view.c3ae7d49.svg";